module.exports = __webpack_public_path__ + "media/images/illustrations/mover_packing_boxes-b196db87e6b2bab4e375296ee32eed9b.svg";